"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POINodeRequest = void 0;
const axios_1 = __importStar(require("axios"));
const utils_1 = require("../../utils");
class POINodeRequest {
    constructor(nodeURL) {
        this.getNodeRouteURL = (route) => {
            return `${this.nodeURL}/${route}`;
        };
        this.validateRailgunTxidMerkleroot = async (chain, tree, index, merkleroot) => {
            const route = `validate-txid-merkleroot/${chain.type}/${chain.id}`;
            const url = this.getNodeRouteURL(route);
            const isValid = await POINodeRequest.postRequest(url, {
                tree,
                index,
                merkleroot,
            });
            return isValid;
        };
        this.getLatestValidatedRailgunTxid = async (chain) => {
            const route = `validated-txid/${chain.type}/${chain.id}`;
            const url = this.getNodeRouteURL(route);
            const status = await POINodeRequest.getRequest(url);
            return status;
        };
        this.getPOIsPerList = async (chain, listKeys, blindedCommitmentDatas) => {
            const route = `pois-per-list/${chain.type}/${chain.id}`;
            const url = this.getNodeRouteURL(route);
            const poiStatusListMap = await POINodeRequest.postRequest(url, {
                listKeys,
                blindedCommitmentDatas,
            });
            return poiStatusListMap;
        };
        this.getPOIMerkleProofs = async (chain, listKey, blindedCommitments) => {
            const route = `merkle-proofs/${chain.type}/${chain.id}`;
            const url = this.getNodeRouteURL(route);
            const merkleProofs = await POINodeRequest.postRequest(url, {
                listKey,
                blindedCommitments,
            });
            return merkleProofs;
        };
        this.submitPOI = async (chain, listKey, transactProofData) => {
            const route = `submit-transact-proof/${chain.type}/${chain.id}`;
            const url = this.getNodeRouteURL(route);
            await POINodeRequest.postRequest(url, {
                listKey,
                transactProofData,
            });
        };
        this.nodeURL = nodeURL;
    }
    static async getRequest(url) {
        try {
            const { data } = await axios_1.default.get(url);
            return data;
        }
        catch (err) {
            if (!(err instanceof axios_1.AxiosError)) {
                throw err;
            }
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const errMessage = `${err.message}: ${err.response?.data}`;
            (0, utils_1.sendErrorMessage)(`POI REQUEST ERROR ${url} - ${errMessage}`);
            throw new Error(errMessage);
        }
    }
    static async postRequest(url, params) {
        try {
            const { data } = await axios_1.default.post(url, params);
            return data;
        }
        catch (err) {
            if (!(err instanceof axios_1.AxiosError)) {
                throw err;
            }
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const errMessage = `${err.message}: ${err.response?.data}`;
            (0, utils_1.sendErrorMessage)(`POI REQUEST ERROR ${url} - ${errMessage}`);
            throw new Error(errMessage);
        }
    }
}
exports.POINodeRequest = POINodeRequest;
